import type { WaitConfig } from '@/types/custom-playbooks';

export const WAIT_LIMITS = { hours: 72, days: 365, business_days: 60 };
export function waitConfigError(config: WaitConfig): string | null {
  if (config.mode === 'duration') {
    const limit = WAIT_LIMITS[config.unit];
    if (
      !limit ||
      !Number.isInteger(config.amount) ||
      config.amount < 1 ||
      config.amount > limit
    )
      return 'Wait 1 to 365 days, 1 to 60 business days or 1 to 72 hours';
  } else if (config.mode === 'until_date') {
    if (
      typeof config.field !== 'string' ||
      !config.field.trim() ||
      config.field.length > 512
    )
      return 'Pick a date field';
    if (
      !Number.isInteger(config.offsetDays ?? 0) ||
      (config.offsetDays ?? 0) < -365 ||
      (config.offsetDays ?? 0) > 365
    )
      return 'Use a date offset from -365 to 365 days';
    if (
      config.time !== undefined &&
      !/^([01]\d|2[0-3]):[0-5]\d$/.test(config.time)
    )
      return 'Use a time from 00:00 to 23:59';
    if (
      !['drop', 'continue'].includes(config.ifMissing ?? 'drop') ||
      !['drop', 'continue'].includes(config.ifPast ?? 'continue')
    )
      return 'Choose Drop or Continue for a missing or past date';
  } else return 'Choose a duration or a date for this wait';
  const keys =
    config.mode === 'duration'
      ? ['mode', 'amount', 'unit']
      : ['mode', 'field', 'offsetDays', 'time', 'ifMissing', 'ifPast'];
  if (Object.keys(config).some((key) => !keys.includes(key)))
    return 'This wait contains unsupported settings';
  return null;
}
export function waitSummary(config: WaitConfig, fieldLabel?: string): string {
  if (config.mode === 'duration') {
    const unit =
      config.unit === 'business_days' ? 'business days' : config.unit;
    return `Wait ${config.amount} ${config.amount === 1 ? unit.slice(0, -1) : unit}`;
  }
  const offset = config.offsetDays ?? 0;
  return `Wait until ${offset ? `${Math.abs(offset)} days ${offset < 0 ? 'before' : 'after'} ` : ''}${fieldLabel || config.field || 'a date'}`;
}
